// extracted by mini-css-extract-plugin
export var tabIcon = "pages-account-purchase-__PurchaseProductCatalog-module___tabIcon";
export var tabLabel = "pages-account-purchase-__PurchaseProductCatalog-module___tabLabel";